import React from "react";
import * as styles from "./popup-sheet-content-list.module.scss";
import { classArr } from "../../helper/style-helper";

export interface PopupSheetContentListProps {
	style?: React.CSSProperties;
	className?: string;
	children?: React.ReactNode;
}

export default function PopupSheetContentList(
	props: PopupSheetContentListProps,
) {
	return (
		<div
			style={props.style}
			className={classArr(styles.list, props.className)}
		>
			{props.children}
		</div>
	);
}
